import React from "react";
import { Card, CardContent, Typography, Button } from "@mui/material";
import "./CallToActionCard.css";
import { LINKS } from "../../constants/links";
import { useTranslation } from "react-i18next";

const CallToActionCard = () => {
  const { t } = useTranslation();

  return (
    <Card className="glfr-cta-card">
      <CardContent sx={{ padding: "15px", textAlign: "center" }}>
        <Typography
          variant="h5"
          component="h2"
          sx={{
            fontWeight: 800,
            marginBottom: "12px",
            color: "white",
            letterSpacing: "0.5px",
            textTransform: "none",
            padding: "0 20px",
            lineHeight: 1.3,
            fontSize: {
              xs: "1.5rem",
              sm: "1.75rem",
            },
          }}
        >
          {t("ctaCard.title")}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            marginBottom: "16px",
            color: "white",
            lineHeight: 1.5,
            maxWidth: "600px",
            margin: "24px auto",
          }}
        >
          {t("ctaCard.description")}
        </Typography>

        <Button
          href={LINKS.GLFR_SIGNUP}
          variant="contained"
          sx={{
            backgroundColor: "white",
            padding: "12px 24px",
            borderRadius: "15px",
            textTransform: "none",
            fontSize: "16px",
            fontWeight: "bold",
            minWidth: "250px",
            height: "48px",
            color: "#326038",
            "&:hover": {
              backgroundColor: "#3d7445",
              color: "white",
            },
          }}
        >
          {t("ctaCard.button")}
        </Button>
      </CardContent>
    </Card>
  );
};

CallToActionCard.displayName = "CallToActionCard";

export default CallToActionCard;
